export default __webpack_public_path__ + "static/media/kitchen1.e79f8059.png";